const tintColorLight = '#34d399';
const tintColorDark = '#34d399';

export default {
  light: {
    text: '#e5edff',
    background: '#0c1328',
    tint: tintColorLight,
    tabIconDefault: '#7486ad',
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: '#e5edff',
    background: '#0c1328',
    tint: tintColorDark,
    tabIconDefault: '#7486ad',
    tabIconSelected: tintColorDark,
  },
};
